import { Icon, Tooltip } from '@components';

import theme from '../../../../../themes/colors';

interface AccountTypeInfoProps {
  tooltipContent: {
    id: number;
    title: string;
    text: string;
  }[];
}

const AccountTypeInfo = ({ tooltipContent }: AccountTypeInfoProps) => (
  <div className="flex items-start justify-start">
    <Icon
      name="alert-circle"
      stroke={theme.subText}
      data-tooltip-id="alert-info"
    />
    <Tooltip id="alert-info" place="bottom" className="!w-95">
      {tooltipContent &&
        tooltipContent.map((item, index) => (
          <div
            className={`grid gap-6 ${
              index !== tooltipContent.length - 1 ? 'mb-2' : ''
            }`}
            key={item.id}
          >
            <div className="text-sm text-subText">
              <span className="text-white">{item.title}:</span> {item.text}
            </div>
          </div>
        ))}
    </Tooltip>
  </div>
);

export default AccountTypeInfo;
